// extracted by mini-css-extract-plugin
module.exports = {"npmBgHero":"_8c1ee087","npmBg":"f7728d4c","npmBgLoveOss":"_43683c6d","npmContent":"_8eb61c75","tagline":"fde13d93"};